import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { FormListeners } from '../../../models/beans/form-listeners.abstract';
import { Revisione53State } from '../../../store/revisione53.reducers';
import { SmartToastService } from '@shared/services/smart-toast.service';
import { datiBilancioToastListeners } from './dati-bilancio-toast.listeners';
import { datiBilancioSyncBilancioListeners } from './dati-bilancio-sync-bilancio.listeners';
import { datiBilancioSchedaPrestitoListeners } from './dati-bilancio-scheda-prestito.listeners';
import { datiBilancioRistorniCalcoliListeners } from './dati-bilancio-ristorni-calcoli.listeners';
import { datiBilancioRistorniWarningsListeners } from './dati-bilancio-ristorni-warnings.listeners';
import { datiBilancioBusinessListeners } from './dati-bilancio-business.listeners';
import { ragSocRevIncaricataChoiceListenerHelper } from './dati-bilancio-societa-revisione.listeners';

export class DatiBilancioFormListeners extends FormListeners {
    private readonly store: Store<Revisione53State>;
    private readonly smartToast: SmartToastService;

    constructor(form: FormGroup, store: Store<Revisione53State>, smartToast: SmartToastService) {
        super(form);
        this.store = store;
        this.smartToast = smartToast;
    }

    setListeners(): void {
        datiBilancioSyncBilancioListeners(this.form, this.store);
        datiBilancioSchedaPrestitoListeners(this.form, this.store);
        datiBilancioRistorniCalcoliListeners(this.form, this.store);
        datiBilancioRistorniWarningsListeners(this.form, this.store);
        datiBilancioBusinessListeners(this.form, this.store);
        datiBilancioToastListeners(this.form, this.smartToast);
        ragSocRevIncaricataChoiceListenerHelper(this.form, this.store);
    }
}
